/* eslint-disable no-console */
import React from 'react';
import { Select } from 'ui/components/styled';
import { AdminLayout } from 'ui/components/layouts';
import { DataTable, Icon } from 'ui/components/shared';
import { Container, Title } from 'ui/components/styled';
import { CopyWrapper, FormContainer } from './styles';
import axios from 'helpers/axios';
import { useCompany, useToasts } from 'hooks';

export default function Notifications() {
  const { companies } = useCompany();

  const [selectedCompanies, setSelectedCompanies] = React.useState([]);
  const [emails, setEmails] = React.useState([]);
  const { errorToast, successToast } = useToasts();

  const columns = [
    {
      name: 'Email',
      sortable: true,
      cell: (row) => row,
    },
  ];

  const fetchMembersEmails = async (newSelectedCompanies) => {
    try {
      const { data = [] } = await axios.get('/companies/members/emails', {
        params: {
          companies: newSelectedCompanies.map((company) => company.value),
        },
      });
      setEmails(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectedCompaniesChange = (newSelectedCompanies) => {
    setSelectedCompanies(newSelectedCompanies);
  };

  const handleCopyEmailsClick = async () => {
    try {
      await navigator.clipboard.writeText(emails?.join(';'));
      successToast('Emails copied successfully!');
    } catch (e) {
      errorToast('Error copying emails');
    }
  };

  React.useEffect(() => {
    fetchMembersEmails(selectedCompanies);
  }, [selectedCompanies]);

  return (
    <AdminLayout>
      <Title variant="dark" mx="m" mb="l">
        Notifications
      </Title>
      <FormContainer>
        <Select
          isSearchable
          placeholder="All Companies"
          options={companies.map((company) => ({ label: company.name, value: company.id }))}
          value={selectedCompanies}
          minWidth="200px"
          onChange={handleSelectedCompaniesChange}
          isMulti
          required
          width="auto"
        />
      </FormContainer>

      <Container maxWidth="500px" mb="20px">
        <CopyWrapper onClick={handleCopyEmailsClick} data-cy="copy-emails">
          <Icon icon="copy" size="16px" mr="7px" /> Copy Emails
        </CopyWrapper>
        <DataTable
          columns={columns}
          data={emails}
          subHeaderComponent={null}
          paginationServer={false}
          paginationComponent={null}
        />
      </Container>
    </AdminLayout>
  );
}
